import { defineComponent, mergeModels, useModel, computed, createBlock, openBlock, unref } from "vue";
import { getTimezoneManager as getTimezoneManager$1, getReadableTimezoneName, getSortedTimezoneList } from "@nextcloud/timezones";
import { c as createElementId } from "./createElementId-DhjFt1I9.mjs";
import { r as register, a as t } from "./_l10n-dinIMiE_.mjs";
import { N as NcSelect } from "./NcSelect-DFMnY4fI.mjs";
register();
const timezoneManager = getTimezoneManager$1();
let initialized = false;
function getTimezoneManager() {
  if (!initialized) {
    timezoneManager.registerDefaultTimezones();
    initialized = true;
  }
  return timezoneManager;
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcTimezonePicker",
  props: /* @__PURE__ */ mergeModels({
    additionalTimezones: { default: () => [] },
    uid: { default: createElementId() }
  }, {
    "modelValue": { default: "floating" },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const modelValue = useModel(__props, "modelValue");
    const selectedTimezone = computed({
      set(timezone) {
        modelValue.value = timezone.timezoneId;
      },
      get() {
        for (const additionalTimezone of props.additionalTimezones) {
          if (additionalTimezone.timezoneId === modelValue.value) {
            return {
              cities: [],
              ...additionalTimezone
            };
          }
        }
        return {
          label: getReadableTimezoneName(modelValue.value),
          timezoneId: modelValue.value,
          cities: []
        };
      }
    });
    const options = computed(() => {
      const timezoneManager2 = getTimezoneManager();
      const timezoneList = getSortedTimezoneList(
        timezoneManager2.listAllTimezones(),
        props.additionalTimezones,
        t("Global")
        // TRANSLATORS: This refers to global timezones in the timezone picker
      );
      const timezonesGrouped = [];
      for (const group of Object.values(timezoneList)) {
        timezonesGrouped.push(...group.regions);
      }
      return timezonesGrouped;
    });
    function isSelectable(option) {
      return !option.timezoneId.startsWith("tz-group__");
    }
    function filterBy(option, label, search) {
      const terms = search.trim().split(" ");
      if ("continent" in option) {
        return option.regions.some((region) => {
          return matchTimezoneId(region.timezoneId, terms);
        });
      }
      return matchTimezoneId(option.timezoneId, terms);
    }
    function matchTimezoneId(timezoneId, terms) {
      return terms.every((term) => timezoneId.toLowerCase().includes(term.toLowerCase()));
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NcSelect), {
        modelValue: selectedTimezone.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => selectedTimezone.value = $event),
        "aria-label-combobox": unref(t)("Search for timezone"),
        clearable: false,
        "filter-by": filterBy,
        multiple: false,
        options: options.value,
        placeholder: unref(t)("Type to search time zone"),
        selectable: isSelectable,
        uid: _ctx.uid,
        label: "label"
      }, null, 8, ["modelValue", "aria-label-combobox", "options", "placeholder", "uid"]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcTimezonePicker.vue_vue_type_script_setup_true_lang-BK7HxZja.mjs.map
